<section id="pricing" class="bg-midnight-blue pt-0 sm-pt-50px mt-5 position-relative">
  
  <style>
    /* --- 1. ANIMATIONS --- */
    @keyframes gradient-move {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
    @keyframes glow-border {
      0% { box-shadow: 0 0 5px rgba(255, 65, 108, 0.2), inset 0 0 0px rgba(255, 255, 255, 0); }
      50% { box-shadow: 0 0 20px rgba(255, 65, 108, 0.6), inset 0 0 10px rgba(255, 255, 255, 0.1); }
      100% { box-shadow: 0 0 5px rgba(255, 65, 108, 0.2), inset 0 0 0px rgba(255, 255, 255, 0); }
    }
    @keyframes float-icon {
      0% { transform: translateY(0px) rotate(0deg); }
      50% { transform: translateY(-8px) rotate(5deg); }
      100% { transform: translateY(0px) rotate(0deg); }
    }
    @keyframes btn-pulse {
      0% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7); }
      70% { box-shadow: 0 0 0 15px rgba(255, 255, 255, 0); }
      100% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
    }

    /* --- 2. CARD & TOP BANNER STYLING --- */
    .special-free-card {
      position: relative;
      overflow: hidden;
      background: linear-gradient(-45deg, #c4041c, #ff416c, #8f0819, #c4041c);
      background-size: 400% 400%;
      animation: gradient-move 10s ease infinite, glow-border 4s infinite alternate;
      border: 1px solid rgba(255, 255, 255, 0.2);
      transition: transform 0.3s ease;
      z-index: 1;
      width: 100%;
    }
    .special-free-card:hover {
      transform: scale(1.01);
      border-color: rgba(255, 255, 255, 0.5);
    }
    .floating-smile {
      font-size: 3rem;
      animation: float-icon 4s ease-in-out infinite;
      filter: drop-shadow(0 5px 15px rgba(0,0,0,0.3));
    }
    .feature-list-item {
      display: flex; align-items: center; gap: 10px; margin-bottom: 6px; font-size: 15px; color: white; font-weight: 500;
    }
    .feature-list-item i {
      color: #2ecc71; background: white; border-radius: 50%; padding: 3px; font-size: 10px;
    }
    
    .btn-super-cta {
      background: #ffffff; color: #c4041c; font-weight: 800; text-transform: uppercase;
      padding: 12px 45px; min-width: 260px; 
      white-space: nowrap; justify-content: center; border-radius: 50px; border: none; display: inline-flex; align-items: center; gap: 10px;
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); animation: btn-pulse 2s infinite; box-shadow: 0 10px 20px rgba(0,0,0,0.2);
      cursor: pointer; text-decoration: none;
    }
    .btn-super-cta:hover {
      background: #000000; color: #ffffff; transform: translateY(-3px); box-shadow: 0 15px 30px rgba(0,0,0,0.4);
    }

    /* --- 3. PRICING FOOTER & BUTTONS --- */
    .pricing-footer {
      display: flex;
      gap: 10px;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-top: 10px;
    }

    .view-button, .product-button, .view-button1 {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 5px;
      border-radius: 50px;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      cursor: pointer;
      transition: all 0.3s ease;
      gap: 6px;
      white-space: nowrap;
      border: 1px solid transparent;
    }
    
    /* Standard View Button */
    .view-button {
      background-color: transparent;
      border: 1px solid #c4041c;
      color: #c4041c;
    }
    
    /* Popular Card View Button */
    .view-button1 {
      background-color: white;
      border: 1px solid #c4041c;
      color: #c4041c;
    }
    
    /* Standard Download Button */
    .product-button {
      background-color: #c4041c;
      color: #fff;
      box-shadow: 0 4px 15px rgba(0,0,0,0.3);
      border: 1px solid #c4041c;
    }

    /* DYNAMIC HOVER EFFECT - Unified for all buttons */
    .view-button:hover, 
    .view-button1:hover, 
    .product-button:hover {
      background-color: #000000 !important;
      color: #ffffff !important;
      border-color: #000000 !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0,0,0,0.4);
    }

    /* --- 4. RESPONSIVENESS --- */
    @media (max-width: 480px) {
      .pricing-footer {
        flex-direction: column;
        gap: 8px;
      }
      .view-button, .product-button, .view-button1 {
        width: 100%;
      }
    }
  </style>

  <div class="container ps-3 pe-3 ps-md-7 pe-md-7">
    
    <div class="row justify-content-center mb-40px" 
         data-anime='{ "translateY": [30, 0], "opacity": [0,1], "duration": 1000, "delay": 0, "easing": "easeOutQuad" }'>
      <div class="col-12"> 
        <div class="special-free-card border-radius-8px p-30px d-flex flex-column flex-lg-row align-items-center justify-content-between text-center text-lg-start box-shadow-large">
          <div class="d-flex flex-column flex-md-row align-items-center gap-4 position-relative z-index-2 w-100 w-lg-auto">
            <i class="line-icon-Smile text-white floating-smile"></i>
            <div><h3 class="mb-0 text-white fs-50">₹0</h3></div>
            <div class="d-none d-lg-block border-start border-color-transparent-white-light h-50px mx-4 opacity-4"></div>
            <div class="text-start">
               <div class="text-white fs-20 text-uppercase opacity-7 mb-2 fw-800 ls-1">What's Inside:</div>
               <div class="feature-list-item"><i class="fa-solid fa-check"></i><span>Architectural Floor Plan (.cad, .pdf)</span></div>
               <div class="feature-list-item"><i class="fa-solid fa-check"></i><span>Elevation in 3D (.jpg, .png, .skp)</span></div>
            </div>
          </div>
          <div class="mt-4 mt-lg-0 position-relative z-index-2">
            <a href="#" (click)="openDownload($event)" class="btn-super-cta">
               <span>Download a Free Template</span>
               <i class="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-cols-1 row-cols-lg-3 align-items-center justify-content-center gy-4" id="package_listing" *ngIf="packages.length > 0">
      
      <div *ngFor="let pack of packages; let i = index" class="col-lg-4 col-md-8 px-md-0 pricing-table-style-02 position-relative transition-inner-all md-mb-30px">
        <div *ngIf="i % 3 === 1" class="pricing-tables popular-item border border-color-transparent-white-light bg-midnight-blue text-center border-radius-6px pt-25 pb-25 ps-15 pe-15 box-shadow-quadruple-large">
          <div class="pricing-headers">
            <div class="popular-ribbon alt-font fw-500 fs-14 text-uppercase border-radius-2px d-none"><span>Popular</span></div>
            <i class="line-icon-Business-ManWoman align-middle text-center text-base-color icon-extra-large mb-20px"></i>
            <div class="alt-font text-uppercase fs-16 fw-500">{{pack.name}}</div>
            <h3 class="mb-0 fw-500">₹{{pack.price}}</h3>
          </div>
          <div class="pricing-body pt-20px pb-30px">
            <ul class="list-style-01 ps-0 mb-0">
              <li class="border-color-transparent-white-light pt-10px pb-10px"><span>{{pack.description}}</span></li>
            </ul>
          </div>
          <div class="pricing-footer">
             <button class="view-button1" type="button" [routerLink]="['/viewalltemplate/packages', pack.id]"><i class="fas fa-eye"></i> Preview</button>
             <button class="product-button" type="button" (click)="openDownload($event, pack)"><i class="fas fa-download"></i> Download</button>
          </div>
        </div>

        <div *ngIf="i % 3 !== 1" class="pricing-table border border-color-transparent-white-light text-center border-radius-6px pt-17 pb-17 ps-15 pe-15 box-shadow-large">
          <div class="pricing-header">
            <i class="line-icon-Business-Mens align-middle text-center icon-extra-large mb-20px"></i>
            <div class="alt-font text-uppercase fs-16 fw-500">{{pack.name}}</div>
            <h3 class="mb-0 fw-500">₹{{pack.price}}</h3>
          </div>
          <div class="pricing-body pt-20px pb-30px">
            <ul class="list-style-01 ps-0 mb-0">
              <li class="border-color-transparent-white-light pt-10px pb-10px"><span>{{pack.description}}</span></li>
            </ul>
          </div>
          <div class="pricing-footer">
             <button class="view-button1" type="button" [routerLink]="['/viewalltemplate/packages', pack.id]"><i class="fas fa-eye"></i> Preview</button>
             <button class="product-button" type="button" (click)="openDownload($event, pack)"><i class="fas fa-download"></i> Download</button>
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="packages.length === 0" class="text-center py-5">
      <p class="fs-20 fw-500">No Packages Found</p>
    </div>
  </div>
</section>